<template>
  <div>
    <h2 class="title">Send us a message</h2>
    <p class="description">
      We'd love to hear from you so feel free to drop us a message and we'll get back to you promptly.
      <br />
      <br />
    </p>
    <form role="form" id="contact-form" @submit.prevent="sendmail" v-if="form">
      <label>Your name</label>
      <fg-input
        placeholder="Your Name..."
        v-model="form.name"
        name="name"
        addon-left-icon="now-ui-icons users_circle-08"
      >
      </fg-input>

      <label>Email address</label>
      <fg-input
        placeholder="Email Here..."
        v-model="form.email"
        name="email"
        addon-left-icon="now-ui-icons users_circle-08"
      >
      </fg-input>
      <label>Phone</label>

      <fg-input
        placeholder="Number Here..."
        v-model="form.phone"
        name="phone"
        addon-left-icon="now-ui-icons tech_mobile"
      >
      </fg-input>

      <div class="form-group">
        <label>Your message</label>
        <textarea
          v-model="form.message"
          name="message"
          class="form-control"
          id="message"
          rows="6"
        ></textarea>
      </div>
      <div class="submit text-center">
        <input type="submit" class="btn btn-primary" value="Contact Us">
      </div>
    </form>
  </div>
</template>

<script>
import emailjs from 'emailjs-com'
import { Button, FormGroupInput } from "@/components";
export default {
  name: 'ContactFormNew',
  // bodyClass: "contact-page",
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  data() {
    return {
      emailjs: {
        serviceId: 'service_ip7hfdq',
        templateId: 'template_z27fwhe',
        userId: 'user_Z4lDmCXRAJmGURD0o3VxY'
      },
      form: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
    };
  },
  methods: {
    sendmail (e) {
      const templateParams = {
        name: this.form.name,
        email: this.form.email,
        phone: this.form.phone,
        message: this.form.message
    };

    emailjs.send(this.emailjs.serviceId, this.emailjs.templateId, templateParams, this.emailjs.userId)
      .then((response) => {
        console.log('SUCCESS!', response.status, response.text);
        this.emailToast ('Thank you! We will be in touch shortly')
      }, (err) => {
        this.emailToast (`Something went wrong. Please try calling instead`)
        console.log('FAILED...', err);
      });

      this.form.name = ''
      this.form.email = ''
      this.form.phone = ''
      this.form.message = ''
      
    },

    emailToast (message) {
      this.$toast(message, {
        toastClassName: "my-custom-toast-class"
      })
    }
  }

}
</script>

<style>
.my-custom-toast-class {
  color: #fff;
  background-color: #BAA583;
}
</style>